module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"order":"Pedido","subtotal":"Subtotal","taxes":"Tarifas","discounts":"Descontos","shipping":"Frete","total":"Total"},"en-US":{"order":"Order","subtotal":"Subtotal","taxes":"Taxes","discounts":"Discounts","shipping":"Shipping amount","total":"Total"}}')
  delete Component.options._Ctor
}
